export function normalizeAiMarkdown(content: string): string {
  const normalized = content
    .replace(/\r\n?/g, "\n")
    .replace(
      /^\s*\*\*([^*\n：:]{2,24})[：:]?\*\*\s*[：:]?\s*(\S.*)$/gm,
      "### $1\n\n$2",
    )
    .replace(/^\s*\*\*([^*\n]+)\*\*\s*$/gm, "### $1")
    .replace(
      /^(?!\s*(?:#{1,6}\s|[-*+>]\s|\d+[.)]\s|```))\s*([^\n：:*#]{2,24})[：:]\s*(\S.*)$/gm,
      "### $1\n\n$2",
    );

  return normalized.trim();
}
